import { render, staticRenderFns } from "./TeamPage.vue?vue&type=template&id=6186c83b&"
import script from "./TeamPage.vue?vue&type=script&lang=js&"
export * from "./TeamPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports